export function lazyWithRecovery(importer, featureName) {
  return async () => {
    try {
      const module = await importer();
      sessionStorage.removeItem(`dirnation-lazy-retry:${featureName}`);
      return module;
    } catch (error) {
      console.error("[DIR Nation Globe Fatal]", error);
      const key = `dirnation-lazy-retry:${featureName}`;
      const isChunkFailure = /chunk|dynamically imported|loading css|failed to fetch/i.test(String(error?.message || error));
      if (isChunkFailure && sessionStorage.getItem(key) !== "1") {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  };
}
